import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-113a4020"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-content flex justify-content-center p-2" }
const _hoisted_2 = { class: "centered-content flex-grow-1" }
const _hoisted_3 = { class: "category-container flex flex-wrap mt-4 mb-4" }
const _hoisted_4 = { class: "search-container flex pannel align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ci-action-search" }, null, -1))
const _hoisted_6 = { class: "initial-container flex justify-content-center align-items-center app-label-small font-medium bg-gray-l4" }
const _hoisted_7 = { class: "app-label-small font-bold text-gray-d1" }
const _hoisted_8 = { class: "app-label-small font-bold text-gray-l1" }
const _hoisted_9 = { class: "app-label-small text-gray-l1 font-bold flex flex-row align-content-center align-items-center" }
const _hoisted_10 = { class: "ml-1" }
const _hoisted_11 = { class: "app-label-small font-bold text-gray-l1" }
const _hoisted_12 = {
  key: 0,
  class: "flex align-items-center w-full"
}
const _hoisted_13 = {
  key: 1,
  class: "app-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryCard = _resolveComponent("CategoryCard")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AddAuthorizationDialog = _resolveComponent("AddAuthorizationDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CategoryCard, {
          class: "bg-white action",
          iconClass: "ci-action-add",
          label: "Ajouter un nouveau partage",
          onClick: _ctx.startShare
        }, null, 8, ["onClick"]),
        _createVNode(_component_CategoryCard, {
          class: "bg-gray-l1 text-white",
          iconClass: ['ci-data-presence', 'text-white'],
          count: _ctx.authorizations.length,
          label: "Partages total"
        }, null, 8, ["count"]),
        _createVNode(_component_CategoryCard, {
          class: "bg-green text-white",
          iconClass: ['ci-icon-account', 'text-white'],
          count: _ctx.activeCount,
          label: "connectées"
        }, null, 8, ["count"]),
        _createVNode(_component_CategoryCard, {
          class: "bg-red text-white",
          iconClass: ['ci-icon-placeholder', 'text-white'],
          count: _ctx.inactiveCount,
          label: "Inactifs"
        }, null, 8, ["count"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          class: "flex app-label-small text-gray-l1 font-bold search w-full ml-1",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
          placeholder: "Rechercher"
        }, null, 512), [
          [_vModelText, _ctx.filters['global'].value]
        ])
      ]),
      _createVNode(_component_DataTable, {
        value: _ctx.authorizations,
        filters: _ctx.filters,
        "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters) = $event)),
        responsiveLayout: "stack",
        globalFilterFields: ['fullName', 'email', 'role'],
        class: "mb-3"
      }, {
        empty: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_ProgressSpinner, {
                  mode: "indeterminate",
                  class: "h-2rem md:h-5rem"
                })
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_13, "Il n'y a pas encore de partage"))
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, { filed: "initials" }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_6, _toDisplayString(data.initials), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "fullName",
            header: "NOM",
            filterMatchMode: "contains",
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", _hoisted_7, _toDisplayString(data.fullName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "email",
            header: "EMAIL",
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", _hoisted_8, _toDisplayString(data.email), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "role",
            header: "ROLE",
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("i", {
                  class: _normalizeClass(["ic-15", data.roleIcon])
                }, null, 2),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(data.role)), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "duration",
            header: "NIVEAU DE PARTAGE",
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", _hoisted_11, _toDisplayString(data.duration), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "status",
            header: "STATUS",
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", {
                class: _normalizeClass(["status-tag app-label-micro font-bold text-white", data.statusClass])
              }, _toDisplayString(data.status), 3)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "filters"])
    ]),
    _createVNode(_component_AddAuthorizationDialog, {
      ref: "addAuthorizationDialog",
      userRole: _ctx.currentRole,
      onAuthAdded: _ctx.refreshAuths
    }, null, 8, ["userRole", "onAuthAdded"])
  ]))
}